<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="accidentsTable"
                      :items="items"
                      :search-id="'accident-search'"
                      :fields="fields"
                      :theadTrClass="'first-3-table-cols'"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 3,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"

                      @rowEdit="pushToEdit($event.item)"
                      @rowInfo="showInfo($event.item)"
                      @rowDelete="deleteSelected($event.item.id, `${$tc('message.accident', 1)} ${$event.item.plateNumber}`)">

        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col cols="auto">
              <b-button v-on:click="pushToEdit()" class="b-c-blue mb-3" id="add-accident">
                {{$t('message.add')}}
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="row-after-search" class="mw-100 p-0">
          <b-row class="mb-3">
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" >
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.vehicle', 1)}`"
                                label-for="input-vehicle">
                    <model-list-select id="input-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="vehicleOptions && vehicleOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="vehicleFilter"
                                       :list="vehicleOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="$t('message.driver')"
                                label-for="input-driver">
                    <model-list-select id="input-driver"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="driverDetailedOptions && driverDetailedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="driverFilter"
                                       :list="driverDetailedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.status', 1)} ${$tc('message.accident', 1)}`"
                                label-for="input-status">
                    <model-list-select id="input-status"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="statusOptions && statusOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="statusFilter"
                                       :list="statusOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                label-for="input-activity-sector">
                    <model-list-select id="input-activity-sector"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="activitySectorFilter"
                                       :list="activitySectorOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$tc('message.society', 1)"
                                label-for="input-corp">
                    <model-list-select id="input-corp"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="companyFilter"
                                       :list="companyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.property', 1)}`"
                                label-for="input-owner">
                    <model-list-select id="input-owner"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="ownerFilter"
                                       :list="ownerOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.start', 1).toLowerCase()}`"
                                label-for="start">
                    <b-input-group>
                      <flat-pickr id="start"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="startFilter"
                                  :config="startDateConfig">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button class="fas fa-trash"
                                  @click="startFilter = null"
                                  :disabled="!startFilter">
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$tc('message.date', 1)} ${$tc('message.end', 1).toLowerCase()}`"
                                label-for="end">
                    <b-input-group>
                      <flat-pickr id="end"
                                  :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                  class="form-control"
                                  :readonly="false"
                                  v-model="endFilter"
                                  :config="endDateConfig">
                      </flat-pickr>
                      <div class="input-group-append">
                        <b-button class="fas fa-trash"
                                  @click="endFilter = null"
                                  :disabled="!endFilter">
                        </b-button>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="$refs.accidentsTable.excel($tc('message.accident', 2))">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="infoModal" id="infoModal" :title="$t('info.infoModal')" size="lg">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="4" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.numberPlate', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.plateNumber}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="4" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.brand', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.typeBrand || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="4" lg="4" xl="4">
            <div class="d-flex">
              <h6><b>{{$tc('message.model', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.typeModel || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h6>
              <b class="mr-2">{{$tc('message.society', 1)}}: </b>
              {{infoItem.userCompanyText || $tc('message.emptyValue', 1)}}
            </h6>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h6>
              <b class="mr-2">{{$tc('message.sector', 1)}} {{$tc('message.activity', 1).toLowerCase()}}:
              </b>
              {{infoItem.activitySectorText || $tc('message.emptyValue', 1)}}
            </h6>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h6><b class="mr-2">{{$tc('message.property', 1)}}:</b> {{infoItem.property || $tc('message.emptyValue', 1)}}</h6>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.driver', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.detailedDriverText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.status', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.stateText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.date', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.parsedDate || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.place', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.place || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.damage', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.damage + ',00 €' || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.compensation', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.compensation + ',00 €' || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2 mt-2">
          <b-col class="border-bottom border-c-green">
            <label class="tiny-label c-green">{{$tc('message.counterpart')}}</label>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.name', 1)}}:</b></h6>
              <h6 class="ml-2">{{(infoItem.counterparty && infoItem.counterparty.name) || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.numberPlate', 1)}}:</b></h6>
              <h6 class="ml-2">{{(infoItem.counterparty && infoItem.counterparty.plateNumber) || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6" xl="6">
            <div class="d-flex">
              <h6><b>{{$tc('message.brand', 1)}} {{$tc('message.and', 1).toLowerCase()}} {{$tc('message.model', 1).toLowerCase()}}:</b></h6>
              <h6 class="ml-2">{{(infoItem.counterparty && infoItem.counterparty.vehicleModel) || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="8" lg="8" xl="8">
            <div class="d-flex">
              <h6><b>{{$tc('message.insuranceCompany', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.insuranceCompanyText || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="d-flex">
              <h6><b>{{$tc('message.note', 2)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.note || $tc('message.emptyValue', 1)}}</h6>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-3" v-on:click="closeInfoModal()">Ok</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it.js'

export default {
  name: 'Accident',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('clicked-link', link => {
      if (link.href) {
        this.$router.push(link.href)
      }
    })
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getOptions()
        this.updateLinks()
      }
    })
  },
  data () {
    const genericDateOptions = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: '',
      disable: []
    }
    return {
      DateTime,
      items: [],
      originalItems: [],
      fields: [],
      showCollapse: false,
      isMobile: false,
      vehicleOptions: [],
      statusOptions: [],
      driverOptions: [],
      driverDetailedOptions: [],
      activitySectorOptions: [],
      ownerOptions: [],
      companyOptions: [],
      insuranceCompanyOptions: [],
      vehicleFilter: '',
      driverFilter: '',
      statusFilter: '',
      activitySectorFilter: '',
      ownerFilter: '',
      companyFilter: '',
      startDateConfig: _.cloneDeep(genericDateOptions),
      endDateConfig: _.cloneDeep(genericDateOptions),
      startFilter: null,
      endFilter: null,
      infoItem: {},
      links: [
        '/configuration/accident_state',
        '/configuration/activity_sector',
        '/configuration/company',
        '/configuration/owner'
      ]
    }
  },
  watch: {
    vehicleFilter (val) { this.items = this.getItems(val, this.driverFilter, this.statusFilter, this.activitySectorFilter, this.ownerFilter, this.companyFilter, this.startFilter, this.endFilter) },
    driverFilter (val) { this.items = this.getItems(this.vehicleFilter, val, this.statusFilter, this.activitySectorFilter, this.ownerFilter, this.companyFilter, this.startFilter, this.endFilter) },
    statusFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, val, this.activitySectorFilter, this.ownerFilter, this.companyFilter, this.startFilter, this.endFilter) },
    activitySectorFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, this.statusFilter, val, this.ownerFilter, this.companyFilter, this.startFilter, this.endFilter) },
    ownerFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, this.statusFilter, this.activitySectorFilter, val, this.companyFilter, this.startFilter, this.endFilter) },
    companyFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, this.statusFilter, this.activitySectorFilter, this.ownerFilter, val, this.startFilter, this.endFilter) },
    startFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, this.statusFilter, this.activitySectorFilter, this.ownerFilter, this.companyFilter, val, this.endFilter) },
    endFilter (val) { this.items = this.getItems(this.vehicleFilter, this.driverFilter, this.statusFilter, this.activitySectorFilter, this.ownerFilter, this.companyFilter, this.startFilter, val) }
  },
  methods: {
    clickedLink (link) {
      this.$router.push(link.href)
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      return this.getOptions().then(() => this.getAccidents().then(() => {
        this.$root.$emit('activeLoader', false)
      }).catch(r => {
        this.$root.$emit('activeLoader', false)
        return r
      })).catch(r => {
        this.$root.$emit('activeLoader', false)
        return r
      })
    },
    getOptions () {
      const axiosArray = []
      this.getFields()
      axiosArray.push(this.getVehicle())
      axiosArray.push(this.getDrivers())
      axiosArray.push(this.getEnum('owner', 'ownerOptions', true))
      axiosArray.push(this.getEnum('company', 'companyOptions', true))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions', true))
      axiosArray.push(this.getEnum('accident_state', 'statusOptions', true))
      axiosArray.push(this.getEnum('insurance_company', 'insuranceCompanyOptions'))
      this.updateLinks()
      return Vue.myAll(axiosArray).then(r => r)
    },
    getVehicle () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const editedItems = []
        editedItems.push({value: '', text: vehicles.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption')})
        const activitySectorOptions = this.activitySectorOptions
        const ownerOptions = this.ownerOptions
        const companyOptions = this.companyOptions
        const ownershipTypeOptions = this.ownershipTypeOptions
        const options = {
          activitySectorOptions,
          ownerOptions,
          companyOptions,
          ownershipTypeOptions
        }
        vehicles.forEach(vehicle => {
          const editedVehicle = this.assembleVehicle(vehicle, options)
          editedItems.push(editedVehicle)
        })
        this.vehicleOptions = editedItems
        return this.vehicleOptions
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const editedDrivers = []
        const detailedDrivers = []
        editedDrivers.push({value: '', text: drivers.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption')})
        drivers.forEach(driver => {
          editedDrivers.push({text: `${driver.surname} ${driver.name}`, value: driver.id}),
          detailedDrivers.push({text: `${driver.surname} ${driver.name} - ${driver.taxCode}`, value: driver.id})
        })
        this.driverOptions = editedDrivers
        this.driverDetailedOptions = detailedDrivers
        return drivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getEnum (path, obj) {
      let options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption')})
        items.forEach((item) => {
          options.push({value: item.id, text: item.descr})
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    assembleVehicle (vehicle, options) {
      let newVehicle = this.getMainVehicleData(vehicle)
      newVehicle = this.getExtraData(vehicle, newVehicle, options)
      return newVehicle
    },
    getMainVehicleData (vehicle) {
      const brand = (vehicle.type && vehicle.type.brand) || null
      const model = (vehicle.type && vehicle.type.model) || null
      return {
        value: vehicle.id,
        plateNumber: vehicle.plateNumber,
        typeBrand: brand,
        typeModel: model,
        text: `${vehicle.plateNumber} ${brand ? ' - ' + brand : ''} ${model ? ' - ' + model : ''}`
      }
    },
    getExtraData (oldVehicle, vehicle, options) {
      const activitySector = _.find(options.activitySectorOptions, obj => obj.value === oldVehicle.activitySector && oldVehicle.activitySector !== null)
      const property = _.find(options.ownerOptions, obj => oldVehicle.ownership && obj.value === oldVehicle.ownership.owner && oldVehicle.ownership.owner !== null)
      const userCompany = _.find(options.companyOptions, obj => obj.value === oldVehicle.userCompany && oldVehicle.userCompany !== null)

      vehicle.property = property && property.text
      vehicle.propertyValue = property && property.value
      vehicle.userCompanyText = userCompany && userCompany.text
      vehicle.userCompanyValue = userCompany && userCompany.value
      vehicle.activitySectorText = activitySector && activitySector.text
      vehicle.activitySectorValue = activitySector && activitySector.value
      return _.cloneDeep(vehicle)
    },
    getAccidents () {
      return Vue.myGet(this, '/accidents', 'accidents').then((accidents) => {
        const editedAccidents = []
        accidents.forEach(accident => {
          const foundedStatus = accident.state ? _.find(this.statusOptions, o => o.value === accident.state) : null
          const foundedInsuranceCompany = accident.counterparty.insuranceCompany
            ? _.find(this.insuranceCompanyOptions, obj => obj.value === accident.counterparty.insuranceCompany) : null
          let editedAccident = accident
          editedAccident = this.getDriverData(editedAccident)
          editedAccident = this.getVehicleData(editedAccident)
          editedAccident.parsedDate = editedAccident.ts ? DateTime.fromMillis(editedAccident.ts).toFormat('dd-MM-yyyy') : '- - - - -'
          editedAccident.stateText = foundedStatus ? foundedStatus.text : '- - - - -'
          editedAccident.counterpartName = accident.counterparty.name || '- - - - -'
          editedAccident.counterpartplateNumber = accident.counterparty.plateNumber || '- - - - -'
          editedAccident.counterpartModel = accident.counterparty.vehicleModel || '- - - - -'
          editedAccident.insuranceCompanyText = foundedInsuranceCompany ? foundedInsuranceCompany.text : '- - - - -'
          editedAccidents.push(editedAccident)
        })
        this.items = _.orderBy(editedAccidents, 'plateNumber')
        this.originalItems = _.cloneDeep(this.items)
        return editedAccidents
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getDriverData (item) {
      const editedObj = _.cloneDeep(item)
      const foundedDriver = item.driverId ? _.find(this.driverOptions, obj => obj.value === item.driverId) : null
      if (foundedDriver) {
        editedObj.driverText = foundedDriver.text
      }
      return editedObj
    },
    getVehicleData (item) {
      const editedObj = _.cloneDeep(item)
      const vehicles = this.vehicleOptions
      const foundedVehicle = item.vehicleId ? _.find(vehicles, obj => obj.value === item.vehicleId) : null
      if (foundedVehicle) {
        editedObj.plateNumber = foundedVehicle.plateNumber || '- - - - -'
        editedObj.typeBrand = foundedVehicle.typeBrand || '- - - - -'
        editedObj.typeModel = foundedVehicle.typeModel || '- - - - -'
        editedObj.property = foundedVehicle.property || '- - - - -'
        editedObj.propertyValue = foundedVehicle.propertyValue || '- - - - -'
        editedObj.userCompanyText = foundedVehicle.userCompanyText || '- - - - -'
        editedObj.userCompanyValue = foundedVehicle.userCompanyValue || '- - - - -'
        editedObj.activitySectorText = foundedVehicle.activitySectorText || '- - - - -'
        editedObj.activitySectorValue = foundedVehicle.activitySectorValue || '- - - - -'
      }
      return editedObj
    },
    getFields () {
      this.fields = [
        { key: 'edit', label: '', hideInExcel: true },
        { key: 'info', label: '', hideInExcel: true },
        { key: 'delete', label: '', hideInExcel: true },
        { key: 'plateNumber', label: this.$tc('message.numberPlate', 1), sortable: true, sortDirection: 'desc' },
        { key: 'typeBrand', label: this.$t('message.brand'), sortable: true, sortDirection: 'desc' },
        { key: 'typeModel', label: this.$tc('message.model', 1), sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$tc('message.society', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'property', label: this.$tc('message.property', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'driverText', label: this.$tc('message.driver', 1), sortable: true, sortDirection: 'desc' },
        { key: 'stateText', label: this.$tc('message.status', 1), sortable: true, sortDirection: 'desc' },
        { key: 'parsedDate', label: this.$tc('message.date', 1), sortable: true, sortDirection: 'desc' },
        { key: 'place', label: this.$tc('message.place', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'damage', label: this.$tc('message.damage', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'compensation', label: this.$tc('message.compensation', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'counterpartName', label: `${this.$tc('message.counterpart', 1)} ${this.$tc('message.name', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'counterpartplateNumber', label: `${this.$tc('message.counterpart', 1)} ${this.$tc('message.numberPlate', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'counterpartModel', label: `${this.$tc('message.counterpart', 1)} ${this.$tc('message.model', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'insuranceCompanyText', label: this.$tc('message.insuranceCompany', 1), sortable: true, sortDirection: 'desc', hideInTable: true },
        { key: 'note', label: this.$tc('message.note', 2), sortable: true, sortDirection: 'desc', hideInTable: true }
      ]
    },
    pushToEdit (item) {
      item && item.id ? this.$router.push({
        name: 'EditAccident', params: { id: item.id }
      }) : this.$router.push({ name: 'EditAccident', params: { id: 'new' } })
    },
    deleteSelected (id, descr) {
      this.$root.$emit('deleteItem', { path: `/accidents/${id}`, description: descr, redirect: this.$route.path })
    },
    showInfo (item) {
      if (!item.damage) item.damage = 0
      if (!item.compensation) item.compensation = 0

      this.infoItem = item
      const detailedDriver = item.driverId ? _.find(this.driverDetailedOptions, obj => obj.value === item.driverId) : null
      if (detailedDriver) {
        this.infoItem.detailedDriverText = detailedDriver.text
      }
      this.$refs.infoModal.show()
    },
    dateChanged (start, end) {
      this.startDateConfig.maxDate = end ? end.toSQL() : null
      this.endDateConfig.minDate = start ? start.toSQL() : null
    },
    closeInfoModal () {
      this.$refs.infoModal.hide()
      this.infoItem = {}
    },
    getItems (vehicle, driver, status, activity, owner, company, start, end) {
      let allItems = _.cloneDeep(this.originalItems)
      const parsedStart = start ? DateTime.fromSQL(start) : false
      const parsedEnd = end ? DateTime.fromSQL(end) : false

      if (vehicle && vehicle !== '') {
        allItems = _.filter(allItems, obj => obj.vehicleId === _.find(this.vehicleOptions, obj => obj.value === vehicle).value)
      }
      if (driver && driver !== '') {
        allItems = _.filter(allItems, obj => obj.driverId === _.find(this.driverOptions, obj => obj.value === driver).value)
      }
      if (status && status !== '') {
        allItems = _.filter(allItems, obj => obj.state === _.find(this.statusOptions, obj => obj.value === status).value)
      }
      if (activity && activity !== '') {
        allItems = _.filter(allItems, obj => obj.activitySectorValue === _.find(this.activitySectorOptions, obj => obj.value === activity).value)
      }
      if (company && company !== '') {
        allItems = _.filter(allItems, obj => obj.userCompanyValue === _.find(this.companyOptions, obj => obj.value === company).value)
      }
      if (owner && owner !== '') {
        allItems = _.filter(allItems, obj => obj.propertyValue === _.find(this.ownerOptions, obj => obj.value === owner).value)
      }
      if (parsedStart) {
        allItems = _.filter(allItems, obj => obj.ts ? obj.ts >= parsedStart.ts : null)
      }
      if (parsedEnd) {
        allItems = _.filter(allItems, obj => obj.ts ? obj.ts <= parsedEnd.ts : null)
      }

      this.dateChanged(parsedStart, parsedEnd)
      return allItems
    },
    resetFilters () {
      this.vehicleFilter = ''
      this.driverFilter = ''
      this.statusFilter = ''
      this.activitySectorFilter = ''
      this.ownerFilter = ''
      this.companyFilter = ''
      this.startFilter = null
      this.endFilter = null
      this.$refs.accidentsTable.resetSearch()
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    }
  }
}
</script>

<style scoped>
  h6 {
    word-wrap: break-word;
    width: 75%;
  }
</style>
